// Generated by ReScript, PLEASE EDIT WITH CARE

import * as I18n from "../../primitives/I18n.res.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as SelectNumberRangeFilter from "../../resources/selection-and-input/SelectNumberRangeFilter.res.js";

function CatalogStockRangeSelect(props) {
  return JsxRuntime.jsx(SelectNumberRangeFilter.make, {
    label: I18n.t("Stock"),
    precision: 3,
    formatValue: value => I18n.decimalFormat(undefined, 0, 3, undefined, value),
    disabled: props.disabled,
    disabledTooltip: I18n.t("Please select a shop beforehand."),
    value: props.value,
    onChange: props.onChange
  });
}

let make = CatalogStockRangeSelect;

export {
  make,
}
/* I18n Not a pure module */
